<template>
  <div>
    <DrInput
      id="password"
      v-model="password"
      v-bind="$attrs"
      :type="(show = showPassword ? 'text' : 'password')"
      :value="value"
      :error="validationError"
      class="relative mb-3"
      v-on="listeners"
    >
      <template v-slot:help>
        <div class="password-strength">
          <div
            v-for="(validator, index) in passwordValidator"
            :key="index"
            :class="['bg-grey-400', { 'validator-passed': validCount > index }, { [validColor]: validCount > index }]"
          />
        </div>
      </template>
    </DrInput>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, String, Number],
      default: '',
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      password: null,
      passwordValidator: [
        {
          text: 'Password requires an uppercase letter',
          rule: '(?=.*[A-Z])',
          passed: false,
        },
        {
          text: 'Password requires a number or symbol',
          rule: '(?=.*[!0-9@#$%^&])',
          passed: false,
        },
        {
          text: 'Password must be at least 8 characters long',
          rule: '^.{8,}$',
          passed: false,
        },
      ],
    }
  },
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event),
      }
    },
    validCount () {
      return this.passwordValidator.reduce((acc, curr) => {
        const valid = curr.passed
        return valid ? acc + 1 : acc
      }, 0)
    },
    validColor () {
      if (this.validCount === 1) return 'bg-red-500'
      if (this.validCount === 2) return 'bg-yellow-400'
      return 'bg-green-500'
    },
    validationError () {
      const err = this.$store.getters['shared/error']
      if (err && err.code === 'auth/weak-password') {
        for (const i in this.passwordValidator) {
          if (!this.passwordValidator[i].passed) return this.passwordValidator[i].text
        }
      }
      return this.$attrs.err
    },
    allValid () {
      return this.validCount === this.passwordValidator.length
    },
  },
  watch: {
    password () {
      this.validatePassword()
    },
    allValid (val) {
      this.$emit('valid', val)
    },
  },
  methods: {
    validatePassword () {
      this.passwordValidator.forEach((validator, index) => {
        const regex = new RegExp(validator.rule)
        if (!regex.test(this.password)) {
          this.passwordValidator[index].passed = false
        } else {
          this.passwordValidator[index].passed = true
        }
      })
    },
  },
}
</script>

<style scoped>
.text-2xs,
.text-2xs span {
  @apply text-2xs;
}

.password-strength {
  top: 20px;
  right: 12px;

  @apply absolute flex items-center;
}

.password-strength > div {
  width: 5px;
  height: 5px;
  margin-left: 4px;
  transition: all 0.5s ease;

  @apply rounded;
}
</style>
